import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';
import { config } from 'config';
import { history } from 'global';

export const configureAppInsights = (): void => {
    const reactPlugin = new ReactPlugin();
    const appInsights = new ApplicationInsights({
        config: {
            instrumentationKey: config.apiKey.appInsights,
            extensions: [reactPlugin],
            extensionConfig: {
                [reactPlugin.identifier]: { history },
            },
        },
    });
    appInsights.loadAppInsights();
    appInsights.trackPageView();
};
